import React, { FC } from 'react'

import { sumBy } from 'lodash'

import { RankNumber } from '../../../components/RankNumber'

import { IRegistrationByDayInterface } from '../../../../../../../models/registrations-by-day/registrationByDay.interface'

interface DefaultScoringTotalProps {
  row: IRegistrationByDayInterface
  publishPrize: boolean
  prizeMoney: string
  handleModalOpen: () => void
  index: number
}
export const DefaultScoringTotal: FC<DefaultScoringTotalProps> = ({
  row,
  publishPrize,
  prizeMoney,
  handleModalOpen,
  index,
}) => {
  let max = 0
  if (row.score?.judges) {
    max = sumBy(row.score.judges[0]?.sections, (section) => section.max)
  }

  return (
    <div className="md:ml-auto flex gap-2.5 justify-center items-center">
      <div className="md:text-right">
        <div className="flex gap-2 justify-end">
          {row.isQualify && <span className={'font-semibold '}>Q •</span>}
          <span className={'font-semibold '}> {row.score?.totalPoints}</span>
          {row.score?.sheet?.name &&
            row.score?.sheet?.name !== 'Default' &&
            row.score?.sheet?.name !== 'Equitation' &&
            row.score?.sheet?.name !== 'Hunters' && (
              <>
                <span>•</span>
                <span>
                  {Number(row.score?.totalPoints) > 0 && max > 0
                    ? ((Number(row.score?.totalPoints) / Number(max)) * 100).toFixed(2)
                    : 0}
                  %
                </span>
              </>
            )}
        </div>
        {publishPrize ? (
          <div className="opacity-50 cursor-pointer text-[14px]" onClick={handleModalOpen}>
            {prizeMoney && row.score?.earning ? (
              <span className="underline">
                ${(Number(prizeMoney) * Number(row.score.earning)) / 100}
              </span>
            ) : (
              <span className="underline text-SeabiscuitDark200ThemeColor/50">$0</span>
            )}
          </div>
        ) : (
          <div
            className="opacity-50 underline cursor-pointer text-[14px]"
            onClick={handleModalOpen}
          >
            More
          </div>
        )}
      </div>
      <RankNumber
        rank={Number(row.score?.rank) || index + 1}
        totalPoints={row.score?.totalPoints}
      />
    </div>
  )
}
